import React, { useContext } from 'react'
import Price from './price'
import PriceStriked from './price-striked'
import ESW_CLASSNAMES from '../components/esw-classnames'
import AppContext from '../context/app'
import { BASE_COUNTRY_ISO } from '../../constants'
import PercentageOff from './percentage-off'

export default function PriceDisplay(props) {
    const {
        cart,
        prices,
        country,
    } = useContext(AppContext)

    const {
        item,
        product,
        quantity,
        className = 'd-flex a-center gap-2',
        eswPriceClassName = ESW_CLASSNAMES.PAGE_PRICE,
        eswPriceStrikedClassname = ESW_CLASSNAMES.PAGE_PRICE,
        style,
        showSaleInfo
    } = props

    const property = process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
        'pimcoreProductionId' : 
        'pimcoreStagingId'

    const id = product[property]
    const iso = country?.countryIso || BASE_COUNTRY_ISO
    
    const price = (prices && prices[id]) ? prices[id][iso] : undefined
    const hasPromotion = price ? price.hasOwnProperty('promotion_price') : undefined

    // console.log(price)

    if(showSaleInfo && prices && hasPromotion) return (
        <div className='d-flex flex-column gap-1'>
            <div className='d-flex gap-2'>
                <PriceStriked
                    item={item}
                    product={product}
                    quantity={quantity}
                    style={{ fontSize: 18 }}
                    eswPriceStrikedClassname={eswPriceStrikedClassname}
                />
                <span
                    className='bg-primary d-flex align-items-center px-2'
                    style={{ fontSize: 16, fontWeight: 800, minWidth: 'max-content' }}
                >
                    -<PercentageOff price={price} />%
                </span>
                <span
                    className='d-flex align-items-center uppercase white bg-black px-2'
                    style={{ fontSize: 16, fontWeight: 600, minWidth: 'max-content' }}
                >
                    {price?.promotion_name}
                </span>
            </div>
            <Price
                item={item}
                product={product}
                quantity={quantity}
                eswPriceClassName={eswPriceClassName}
            />
        </div>
    )

    return (
        <p
            className={className + ' mb-0 d-flex align-items-center gap-2'}
            style={{
                ...style,
                minHeight: style?.fontSize * 1.5, // prevent layout shift
            }}
        >
            {quantity && <span className={`${ESW_CLASSNAMES.CARTITEM_QUANTITY} visually-hidden`}>
                {quantity}
            </span>}

            <Price
                item={item}
                product={product}
                quantity={quantity}
                eswPriceClassName={eswPriceClassName}
                style={{ fontSize: style?.fontSize }}
            />

            <PriceStriked
                item={item}
                product={product}
                quantity={quantity}
                style={{ fontSize: style?.fontSize * 0.8 }}
                eswPriceStrikedClassname={eswPriceStrikedClassname}
            />

            {Number(item?.discount_applied) > 0 && <span
                style={{ fontSize: style?.fontSize * 0.7 }}
                className='text-secondary'
            >
                [{cart?.voucher_code}]
            </span>}
        </p>
    )
}
